import { Component ,ElementRef} from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
declare var $:any;


@Component({
  selector: 'app-faq-add-edit',
  templateUrl: './faq-add-edit.component.html',
  styleUrls: ['./faq-add-edit.component.scss']
})

export class FaqAddEditComponent {
  public loading:boolean = false;
  public submitted:boolean = false;
  public CurrentDetail:any=[];
  public CurrentUrl:any=this.router.url;

  staticData = new FormGroup({
    question:new FormControl('',Validators.compose([
      Validators.required ])),
    answer:new FormControl('',Validators.compose([
      Validators.required ])),
  })
  
   get f() { return this.staticData.controls; }

  constructor(private el: ElementRef,public router: Router, public service: GlobalService) {   
    if(this.CurrentUrl !='/faq-add'){
      this.CurrentDetail= JSON.parse(localStorage.getItem('hva_faq')|| '{}');
    }
  }

  ngOnInit(): void {
  }


  Onsubmit(){
    this.submitted = true;    
      let userdetail = this.staticData;
      if(userdetail.valid){
        var detail=
        {
          "question": this.CurrentDetail.question,
          // "status": this.CurrentDetail.slug,
          "answer": userdetail.value.answer
        }
        var url='';
        this.loading=true;
        if(this.CurrentUrl =='/faq-add'){
          url="faq/add";
          this.service.PostApis(detail,url).subscribe(((response:any)=>{
            if(response.success ==1){         
              this.staticData.reset();
              this.submitted = false;  
              this.loading=false; 
              this.service.back(); 
            } else {
              this.service.dangerAlert(response.message);
              this.loading=false;
            }
          }), (error:any) => {
            this.loading=false;
          });
        } else {
          url="faq/update/"+this.CurrentDetail._id;
          this.service.updateApi1(detail,url).subscribe(((response:any)=>{
            if(response.success ==1){         
              this.staticData.reset();
              this.submitted = false;  
              this.loading=false; 
              this.service.back(); 
            } else {
              this.service.dangerAlert(response.message);
              this.loading=false;
            }
          }), (error:any) => {
            this.loading=false;
          });
        }       
      } else{
        this.loading = false
        userdetail.markAllAsTouched();
        this.scrollToFirstInvalidControl();  
      }
  }
  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "form .ng-invalid"
    );
    // firstInvalidControl.focus(); //without smooth behavior
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: "smooth"
    });
  }
  
  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }
}
